import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import CheckBox from "@material-ui/icons/CheckBox";
import moment from "moment";
import {Tooltip} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {confirmAlert} from "react-confirm-alert";

export default class FinancialEdits extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Financial_Edits._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.filter_status = 'all';
	}

	componentDidMount() {
		if (typeof super.componentDidMount === 'function') {
			super.componentDidMount();
		}
		this.financialEditPoll = setInterval(() => {
			this.refreshFinancialEdits();
		}, 30000);
	}

	componentWillUnmount() {
		if (this.financialEditPoll) {
			clearInterval(this.financialEditPoll);
			this.financialEditPoll = null;
		}
		if (typeof super.componentWillUnmount === 'function') {
			super.componentWillUnmount();
		}
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.filter_status && this.state.filter_status && (prevState.filter_status !== this.state.filter_status)) {
			this.state.page = 0;
			await this.fetchData({
				page: 0,
				pageSize: this.state.limit,
				sorted: this.state.sorted || [],
			});
		}
	}

	notifySessionCheck = () => {
		if (typeof this.props.onSessionCheck === 'function') {
			this.props.onSessionCheck();
		}
	}

	refreshFinancialEdits = () => {
		if (this.state.loading) {
			this.notifySessionCheck();
			return;
		}
		this.fetchData({
			page: this.state.page || 0,
			pageSize: this.state.limit,
			sorted: this.state.sorted || [],
		}, true);
		this.notifySessionCheck();
	}

	fetchData = async (state, silent = false) => {
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.status = this.state.filter_status;
		if (!silent) {
			this.setState({loading: true});
		}
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	handleApproveOrDeny = async ({object, approve, notes}) => {
		await confirmAlert({
			title: `Confirm Financial Edit ${approve ? "Approval" : "Denial"}`,
			message: `Are you sure you want to ${approve ? "approve" : "deny"} this edit request? This cannot be undone, and if future edits are required the engineer will be required to submit a new one.`,
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							let model = new API.BuildClass(Types.Financial_Edits._name, API.RequestType.UPDATE);
							model.object = object;
							model.object.approved = approve;
							model.object.requested_json = notes;
							try {
								await model.submit(null, 'POST');
							} catch (error) {
							}
							await this.fetchData();
							this.notifySessionCheck();
							this.setState({edit_modal: false})
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Created",
				id: "created",
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => obj.created ? moment(obj.created).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Engineer",
				id: "engineer",
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => (obj.engineer)
			},
			{
				Header: "Customer",
				id: "customer",
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => obj.customer,
				Cell: (props) => {
					return (
						<span>
							<Link to={`/tickets/${props.original.ticket}`}>
								{props.original.customer}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Status",
				id: "approved",
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => (obj.status)
			},
			{
				Header: "Actioned",
				id: "modified",
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => obj.modified ? moment(obj.modified).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Actioned By",
				id: "modifier",
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => (obj.approver)
			},
			{
				Header: "Request Notes",
				id: "notes",
				accessor: (obj) => obj.notes,
				style: {whiteSpace: "nowrap"},
				width: 350, // Set a minimum width
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Financial_Edits_Object} obj */
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Tooltip title={props.original.approved === null ? "Open the review modal." : "This request has already been actioned on. If another edit is needed the engineer must submit a new one."}>
							<Button color={props.original.approved === null ? "primary" : "secondary"}
							        size={"sm"} onClick={() => {
										this.setState({edit_modal: true, request_object: props.original, helpdesk_notes: props.original.requested_json ?? ""})
							}}>
								<PriorityHigh fontSize={'small'}/>
							</Button>
						</Tooltip>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Financial Edits')}
							<ButtonGroup>
								<Button
									onClick={() => {
										this.setState({filter_status: 'all', page: 0})
									}}
									outline={this.state.filter_status !== 'all'}
									active={this.state.filter_status === 'all'}
									color={'info'}
								>
									All
								</Button>
								<Button
									onClick={() => {
										this.setState({filter_status: 'pending', page: 0})
									}}
									outline={this.state.filter_status !== 'pending'}
									active={this.state.filter_status === 'pending'}
									color={'info'}
								>
									Pending
								</Button>
								<Button
									onClick={() => {
										this.setState({filter_status: 'approved', page: 0})
									}}
									outline={this.state.filter_status !== 'approved'}
									active={this.state.filter_status === 'approved'}
									color={'info'}
								>
									Approved
								</Button>
								<Button
									onClick={() => {
										this.setState({filter_status: 'denied', page: 0})
									}}
									outline={this.state.filter_status !== 'denied'}
									active={this.state.filter_status === 'denied'}
									color={'info'}
								>
									Denied
								</Button>
							</ButtonGroup>
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>

				<Modal
					isOpen={this.state.edit_modal}
					toggle={() => {
						this.setState({edit_modal: false})
					}}
					size={"md"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Approve or Deny
					</ModalHeader>
					<ModalBody>
						<div className={'row'}>
							<div className={'col-12'}>
								<div className="form-group">
									<TextField
										fullWidth={true}
										size={"medium"}
										label={"Request Notes"}
										value={this.state.request_object?.notes}
										variant="outlined"
										multiline={true}
										rows={4}
										disabled={true}
									/>
								</div>
							</div>
						</div>
						<div className={'row'}>
							<div className={'col-12'}>
								<div className="form-group">
									<TextField
										fullWidth={true}
										size={"medium"}
										label={"Helpdesk Notes"}
										value={this.state.helpdesk_notes}
										variant="outlined"
										multiline={true}
										disabled={this.state.request_object?.approved !== null}
										rows={4}
										onChange={(e) =>
											this.setState({helpdesk_notes: e.currentTarget.value})}
									/>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						{this.state.request_object?.approved === null && <Button color="primary" onClick={async () => {
							await this.handleApproveOrDeny({object: this.state.request_object, approve: 1, notes: this.state.helpdesk_notes})
						}}>Approve</Button>}

						{this.state.request_object?.approved === null && <Button color="danger" onClick={async () => {
							await this.handleApproveOrDeny({object: this.state.request_object, approve: 0, notes: this.state.helpdesk_notes})
						}}>Deny</Button>}

						<Button color="secondary" onClick={() => {
							this.setState({edit_modal: false})
						}}>Close</Button>
					</ModalFooter>
				</Modal>

			</Card>
		)
	}
}
